$(document).on('shopify:section:load', function() {
    
    if ($('.youtube-slider').length) {
        $('.youtube').each(function() {
            let videoId = $(this).data('id');
            let thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
            $(this).css('background-image', `url(${thumbnailUrl})`);

            $(this).on('click', function() {
                let iframeUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
                let iframe = `<iframe src="${iframeUrl}" frameborder="0" allowfullscreen></iframe>`;

                $('.youtube-slider .watch').fadeIn();
                $('.youtube-slider .iframe').html(iframe);

                $('html, body').css('overflow', 'hidden');
            });
        });

        $('.watch i').on('click', function() {
            $('.youtube-slider .watch').fadeOut();
            $('.youtube-slider .iframe').html('');

            $('html, body').css('overflow', 'auto');
        });

        $('.youtube-slider .owl-carousel').owlCarousel({
            items: 3,
            nav: false,
            dots: true,
            margin: 20,
            smartSpeed: 300,
            stagePadding: 50,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 0
                },
                768: {
                    items: 2,
                    stagePadding: 0
                },
                1280: {
                    items: 3,
                    stagePadding: 50
                }
            }
        });
    }

    const iframes = document.querySelectorAll('.youtube-slider .youtube');
    iframes.forEach((iframe, index) => {
        const videoId = $(iframe).data('id');
        const apiUrl = `https://noembed.com/embed?url=https://www.youtube.com/watch?v=${videoId}`;

        fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
                const titleElement = document.getElementsByClassName('video-title')[index];
                const titleElement2 = document.getElementsByClassName('video-title-top')[index];
                // const authorNameElement = document.getElementsByClassName('author-name')[index];

                titleElement.textContent = data.title;
                titleElement2.textContent = data.title;
                // authorNameElement.textContent = data.author_name;
            })
            .catch(error => {
                console.error('Error fetching video details:', error);
                const titleElement = document.getElementsByClassName('video-title')[index];
                const titleElement2 = document.getElementsByClassName('video-title-top')[index];
                // const authorNameElement = document.getElementsByClassName('author-name')[index];

                titleElement.textContent = 'Error fetching video title';
                titleElement2.textContent = 'Error fetching video title';
                // authorNameElement.textContent = 'Error fetching author name';
            });
    });

});

$(document).ready(function() {

    if ($('.youtube-slider').length) {
        $('.youtube').each(function() {
            let videoId = $(this).data('id');
            let thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
            $(this).css('background-image', `url(${thumbnailUrl})`);

            $(this).on('click', function() {
                let iframeUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
                let iframe = `<iframe src="${iframeUrl}" frameborder="0" allowfullscreen></iframe>`;

                $('.youtube-slider .watch').fadeIn();
                $('.youtube-slider .iframe').html(iframe);

                $('html, body').css('overflow', 'hidden');
            });
        });

        $('.watch i').on('click', function() {
            $('.youtube-slider .watch').fadeOut();
            $('.youtube-slider .iframe').html('');

            $('html, body').css('overflow', 'auto');
        });

        $('.youtube-slider .owl-carousel').owlCarousel({
            items: 3,
            nav: false,
            dots: true,
            margin: 20,
            smartSpeed: 300,
            stagePadding: 50,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 0
                },
                768: {
                    items: 2,
                    stagePadding: 0
                },
                1280: {
                    items: 3,
                    stagePadding: 50
                }
            }
        });
    }

    const iframes = document.querySelectorAll('.youtube-slider .youtube');
    iframes.forEach((iframe, index) => {
        const videoId = $(iframe).data('id');
        const apiUrl = `https://noembed.com/embed?url=https://www.youtube.com/watch?v=${videoId}`;

        fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
                const titleElement = document.getElementsByClassName('video-title')[index];
                const titleElement2 = document.getElementsByClassName('video-title-top')[index];
                // const authorNameElement = document.getElementsByClassName('author-name')[index];

                titleElement.textContent = data.title;
                titleElement2.textContent = data.title;
                // authorNameElement.textContent = data.author_name;
            })
            .catch(error => {
                console.error('Error fetching video details:', error);
                const titleElement = document.getElementsByClassName('video-title')[index];
                const titleElement2 = document.getElementsByClassName('video-title-top')[index];
                // const authorNameElement = document.getElementsByClassName('author-name')[index];

                titleElement.textContent = 'Error fetching video title';
                titleElement2.textContent = 'Error fetching video title';
                // authorNameElement.textContent = 'Error fetching author name';
            });
    });

});